import React, { useState } from 'react';

import { useAppDispatch, useAppSelector } from 'state/hooks';
import {
  selectInColorBlindMode,
  setInColorBlindMode,
} from 'state/workflowSlice';

import { ColorScheme, LegendSettings } from 'appTypes';
import { getMetricColorSchemes } from 'features/chart/colorMaps';
import { LegendSettingsModal } from 'features/map/LegendSettingsModal';
import { MapMetricLegend } from 'features/map/MapMetricLegend';
import {
  IMetricLegendConfig,
  LegendStops,
} from 'features/workflow_timeline/metricsOptions';

export function QueuingMapLegend() {
  const dispatch = useAppDispatch();
  const colorBlindMode = useAppSelector(selectInColorBlindMode);
  const [showSettings, setShowSettings] = useState(false);

  const stops: LegendStops = [
    { label: ['Freeflow', '0'], value: 1 },
    { label: ['', '30'], value: 0.7 },
    { label: ['', '50'], value: 0.5 },
    { label: ['', '60'], value: 0.4 },
    { label: ['', '75'], value: 0.25 },
    { label: ['', '90'], value: 0.1 },
    { label: ['Congested', '100'], value: 0.0 },
  ];

  const setting: IMetricLegendConfig = {
    color_schemes: getMetricColorSchemes('congestion', undefined, true),
    legend_stops: stops,
    display_volume_thickness: false,
  };

  const currentColorScheme: ColorScheme = colorBlindMode ? 'neutral' : 'green';
  const selectedColors = setting.color_schemes.discrete[currentColorScheme];

  const handleLegendSettingsChange = (legendSettings: LegendSettings) => {
    dispatch(setInColorBlindMode(legendSettings.scheme === 'neutral'));
  };

  const initialLegendSettings: LegendSettings = {
    type: 'discrete',
    scheme: currentColorScheme,
  };

  return (
    <>
      <MapMetricLegend
        colors={selectedColors}
        stops={setting.legend_stops}
        displayVolumeThickness={false}
        setShowSettings={setShowSettings}
        legendType="discrete"
        title="Congestion"
        reversedDisplay
      />
      <LegendSettingsModal
        initLegendSettings={initialLegendSettings}
        metricSettings={setting}
        showSettings={showSettings}
        setShowSettings={setShowSettings}
        hideTypeSelector
        updateLegendSettings={handleLegendSettingsChange}
        title="Congestion"
        reversedDisplay
      />
    </>
  );
}
